export function formatNumber(value, decimals = 1) {
  if (value === null || value === undefined) return '0';

  const absValue = Math.abs(value);

  if (absValue < 1000) return value.toString();

  const units = [
    { value: 1e9, symbol: 'B' },
    { value: 1e6, symbol: 'M' },
    { value: 1e3, symbol: 'K' }
  ];

  for (const unit of units) {
    if (absValue >= unit.value) {
      return (
        (value / unit.value)
          .toFixed(decimals)
          .replace(/\.0+$/, '') + unit.symbol
      );
    }
  }
}
